import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import { Oval } from "react-loader-spinner";
import Select from "react-select";
import DatePicker from "react-date-picker";
import axios from "axios";
import moment from "moment/moment";

const initialValue = {
  id: null,
  party_id: null,
  payment_type: "Received",
  payment_mode: "BANK",
  remark: "",
  amount: "",
  date: new Date(),
};

const pTypeDrp = [
  { value: "Received", label: "Payment In" },
  { value: "Paid", label: "Payment Out" },
];
const modeTypeDrp = [
  { value: "CASH", label: "Cash" },
  { value: "UPI", label: "UPI" },
  { value: "CARD", label: "Card" },
  { value: "BANK", label: "Bank Transfer" },
  { value: "CHEQUE", label: "Cheque" },
];

const selectStyles = {
  menu: (baseStyles, state) => ({
    ...baseStyles,
    marginTop: 2,
    zIndex: 999,
  }),
};

const AddPayment = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [isError, setError] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [companyDrp, setCompanyDrp] = useState([]);
  const [formValue, setFormValue] = useState(initialValue);
  const [partyDrp, setPartyDrp] = useState([]);

  const getCompanyData = () => {
    axios.post(API_URL.PARTY_LIST,{is_seller: [1]}).then((res) => {
      if (res?.data?.data?.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            label: raw.name,
            value: raw.id,
          };
        });
        setCompanyDrp(pt);
      }
    });
  };

  const getPartyData = () => {
    axios.post(API_URL.PARTY_LIST, {is_seller: [0]}).then((res) => {
      if (res?.data?.data?.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            label: raw.name + " - " + raw.contact_no,
            value: raw.id,
          };
        });
        setPartyDrp(pt);
      }
    });
  };

  const resetForm = () => {
    setFormValue(initialValue);
  };

  const onEdit = () => {
    axios.post(API_URL.PAYMENT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          party_id: res.data.data.party_id,
          date: moment(res.data.data.date, "YYYY-MM-DD").toDate(),
          remark: res.data.data.remark,
          amount: res.data.data.amount,
          payment_mode: res.data.data.payment_mode,
          payment_type: res.data.data.payment_type,
        });
      }
    });
  };

  const onSave = () => {
    setSubmitting(true);
    setError(false);
    if (formValue.party_id && formValue.amount && formValue.date) {
      const url = id ? API_URL.PAYMENT_UPDATE : API_URL.PAYMENT_SAVE;
      let body = {
        amount: formValue.amount,
        party_id: formValue.party_id,
        date: moment(formValue.date).format("YYYY-MM-DD"),
        remark: formValue.remark,
        payment_mode: formValue.payment_mode,
        payment_type: formValue.payment_type,
      };
      if (id) {
        body["id"] = id;
      }
      axios.post(url, body).then((res) => {
        if (res.data.status === 1) {
          if (id) {
            toast.success("Payment Updated Successfully.", {
              autoClose: 3000,
              position: "top-right",
            });
          } else {
            resetForm();
            toast.success("Payment Successfully.", {
              autoClose: 3000,
              position: "top-right",
            });
          }
          setTimeout(() => {
            navigate("/payments/party-payment-ledger", { replace: true });
          }, 100);
        } else {
          toast.error(res.data.data, {
            autoClose: 3000,
            position: "top-right",
          });
        }
        setSubmitting(false);
      });
    } else {
      setError(true);
      setSubmitting(false);
      toast.error("Please enter all required field's");
    }
  };

  const setFormData = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
  };

  useEffect(() => {
    getPartyData();
    getCompanyData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Payment</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/payments/party-payment-ledger"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="payment_type">
                    Type<span className="required-text">*</span>
                  </label>
                  <div
                    className={`${isError && !formValue.payment_type && "error1"}`}
                  >
                    <Select
                      id="payment_type"
                      name="payment_type"
                      options={pTypeDrp}
                      value={
                        pTypeDrp.find((d) => d.value == formValue.payment_type) ||
                        null
                      }
                      styles={selectStyles}
                      onChange={(e) => setFormData("payment_type", e.value)}
                    />
                  </div>
                </div>
              </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="party_id">
                        {formValue.payment_type === "Paid" ? 'Supplier' : 'Party'}<span className="required-text">*</span>
                      </label>
                      <div
                        className={`${
                          isError && !formValue.party_id && "error1"
                        }`}
                      >
                        <Select
                          id="party_id"
                          name="party_id"
                          options={
                            formValue.payment_type === "Paid"
                              ? companyDrp
                              : partyDrp
                          }
                          value={
                            (formValue.payment_type === "Paid"
                              ? companyDrp
                              : partyDrp
                            ).find((d) => d.value === formValue.party_id) || null
                          }
                          styles={selectStyles}
                          onChange={(e) => setFormData("party_id", e.value)}
                        />
                      </div>
                      {/* {isError && !formValue.party_id && <ErrorText />} */}
                    </div>
                  </div>
                  <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="mode_type">
                    Mode<span className="required-text">*</span>
                  </label>
                  <div
                    className={`${isError && !formValue.payment_mode && "error1"}`}
                  >
                    <Select
                      id="mode_type"
                      name="mode_type"
                      options={modeTypeDrp}
                      value={
                        modeTypeDrp.find((d) => d.value == formValue.payment_mode) ||
                        null
                      }
                      styles={selectStyles}
                      onChange={(e) => setFormData("payment_mode", e.value)}
                    />
                  </div>
                </div>
              </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="date">Date</label>
                      <DatePicker
                        id="date"
                        name="date"
                        showIcon={true}
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                        dateFormat={"dd/MM/yyyy"}
                        className="form-control"
                        onChange={(e) => {
                          setFormData("date", e);
                        }}
                        selected={formValue.date}
                        value={formValue.date}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="amount">
                        Amount.<span className="required-text">*</span>
                      </label>
                      <input
                        id="amount"
                        name="amount"
                        type="number"
                        value={formValue.amount}
                        onChange={(e) => setFormData("amount", e.target.value)}
                        className={`form-control ${
                          isError && formValue.amount === "" && "error"
                        }`}
                        placeholder="Enter Amount."
                      />
                      {/* {isError && formValue.amount === "" && <ErrorText />} */}
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="form-group">
                      <label htmlFor="remark">Remark</label>
                      <input
                        id="remark"
                        name="remark"
                        type="text"
                        maxLength={255}
                        value={formValue.remark}
                        onChange={(e) => setFormData("remark", e.target.value)}
                        className={`form-control ${
                          isError && formValue.remark === "" && "error"
                        }`}
                        placeholder="Enter Remark."
                      />
                      {/* {isError && formValue.remark === "" && <ErrorText />} */}
                    </div>
                  </div>
                </div>
                <div className="row mt-3 mb-3">
                  <div className="col-md-8"></div>
                  <div className="col-md-4">
                    <div className="form-group text-right">
                      {/* <button
                        type="button"
                        onClick={resetForm}
                        className="btn btn-secondary mr-2"
                      >
                        Reset
                      </button> */}
                      <button
                        type="submit"
                        onClick={onSave}
                        disabled={isSubmitting}
                        className="btn btn-primary"
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          {isSubmitting && (
                            <Oval
                              height={20}
                              width={20}
                              color="#FAF9F6"
                              wrapperClass="me-2"
                              visible={true}
                              ariaLabel="oval-loading"
                              secondaryColor="#ffffff"
                              strokeWidth={5}
                              strokeWidthSecondary={5}
                            />
                          )}
                          <div>Save</div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPayment;
